import { render, staticRenderFns } from "./deliveriesImg.vue?vue&type=template&id=73291232&scoped=true&"
import script from "./deliveriesImg.vue?vue&type=script&lang=js&"
export * from "./deliveriesImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73291232",
  null
  
)

export default component.exports